export const articles = [
  {
    id: 'xinren-zhinan',
    title: '挣扎吧亚当君新人入门完全指南',
    excerpt: '第一次进入亚当君的世界？这份指南将带你快速了解游戏机制、核心玩法和基础操作，让你在挣扎之旅中少走弯路。',
    content: `## 欢迎来到亚当君的世界

挣扎吧亚当君是一款极具深度的互动叙事作品，每一位玩家都将面对一个核心命题：在命运的洪流中，如何做出属于自己的选择。

### 基础操作

游戏采用**点击式交互**，你只需点击屏幕上的选项即可推进剧情。每一个选择都会影响后续剧情走向，部分关键选择甚至会影响角色的命运走向。

### 核心机制

1. **命运值系统**：每个选择会累积或消耗命运值，命运值的高低决定了你能解锁的剧情分支数量。
2. **好感度系统**：与其他角色的互动会影响好感度，高好感度将解锁隐藏剧情。
3. **记忆碎片**：在游戏过程中收集记忆碎片，拼凑出完整的世界观和隐藏真相。

### 新手建议

对于初次体验的玩家，我们强烈建议第一遍按照直觉做出选择——这样你能获得最真实的沉浸式体验。完成第一条剧情线后，再回头探索不同的可能性。`,
    category: 'gonglue',
    categoryName: '攻略指南',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20warm%20toned%20illustration%20of%20an%20interactive%20narrative%20game%20entrance%20scene%2C%20golden%20light%20pouring%20through%20a%20doorway%2C%20artistic%20Chinese%20ink%20painting%20style%20blended%20with%20modern%20illustration%2C%20dramatic%20atmosphere%2C%20soft%20ambient%20lighting%2C%20clean%20simple%20background&width=800&height=500&seq=article-xinren-01&orientation=landscape',
    date: '2026-07-20',
    readTime: '8分钟',
    slug: 'xinren-zhinan'
  },
  {
    id: 'juese-shendu',
    title: '亚当君角色深度解析：每个人物背后的故事',
    excerpt: '从亚当到莉莉丝，每个角色都承载着独特的故事线。深度剖析主要角色的背景设定、性格特点和剧情走向。',
    content: `## 角色深度解析

### 亚当君——挣扎者

亚当君是本作的核心主角，一个在命运夹缝中挣扎的普通人。他并非传统意义上的英雄，而是一个充满矛盾、犹豫和脆弱的真实人物。

他的故事从一个看似平常的早晨开始——一封神秘的信件彻底改变了他的人生轨迹。在他的旅途中，亚当君需要面对来自外界的压力、内心的恐惧，以及那些无法回避的艰难抉择。

**关键特征**：内心敏感、善于观察、具有强烈的正义感，但缺乏自信。

### 莉莉丝——引导者

莉莉丝是亚当君在旅途中遇到的第一位关键角色。她神秘、优雅且充满智慧，似乎对亚当君的命运了如指掌。

她的真实身份和目的始终笼罩在迷雾之中——她是朋友，是导师，还是隐藏着更深层秘密的存在？这需要玩家在游戏过程中逐步揭晓。`,
    category: 'juese',
    categoryName: '角色解析',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20character%20illustration%20in%20warm%20golden%20and%20crimson%20tones%2C%20silhouetted%20figures%20standing%20in%20contrasting%20light%2C%20Chinese%20artistic%20style%20with%20modern%20anime%20influence%2C%20emotional%20and%20atmospheric%2C%20clean%20background&width=800&height=500&seq=article-juese-01&orientation=landscape',
    date: '2026-07-15',
    readTime: '12分钟',
    slug: 'juese-shendu'
  },
  {
    id: 'juqing-fenxi',
    title: '剧情分支全解析：你的每一个选择都至关重要',
    excerpt: '深入分析挣扎吧亚当君的多线剧情架构，揭示关键节点的分支逻辑和隐藏结局的触发条件。',
    content: `## 剧情分支全解析

挣扎吧亚当君的剧情设计采用了**多线并行**的叙事结构。游戏中共有7条主要剧情线，每条剧情线又包含3-5个不同的结局走向。

### 第一章：觉醒

在这一章中，亚当君首次意识到自己所处的世界并非表面看起来那么简单。关键选择点：

- 是否接受那封神秘信件（影响后续所有剧情走向）
- 面对陌生人时的态度（影响好感度系统初始值）

### 第二章：十字路口

这是游戏中第一个重大的剧情分支点，玩家的选择将决定亚当君进入三条主线中的哪一条。

**重要提示**：第二章的所有选择都是不可逆的，请谨慎对待。`,
    category: 'juqing',
    categoryName: '剧情讨论',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20branching%20path%20concept%20illustration%2C%20warm%20amber%20and%20deep%20red%20color%20palette%2C%20multiple%20paths%20diverging%20in%20a%20mystical%20forest%20scene%2C%20Chinese%20ink%20painting%20aesthetic%2C%20dramatic%20lighting%2C%20clean%20composition&width=800&height=500&seq=article-juqing-01&orientation=landscape',
    date: '2026-07-10',
    readTime: '15分钟',
    slug: 'juqing-fenxi'
  },
  {
    id: 'jiemian-jiexi',
    title: '隐藏结局解锁攻略：你所不知道的真相',
    excerpt: '挣扎吧亚当君中隐藏着多个秘密结局，本篇攻略将为你揭示这些隐藏结局的触发条件和具体步骤。',
    content: `## 隐藏结局解锁攻略

除了明面上的7条主线结局外，挣扎吧亚当君还隐藏着**3个隐藏结局**。这些结局的触发条件极为苛刻，需要玩家在特定章节满足一系列条件。

### 隐藏结局一：黎明之前

触发条件：
1. 第一章中选择接受信件
2. 第二章中选择帮助陌生人
3. 第三章中收集全部5个记忆碎片
4. 在第四章的关键节点选择「放弃」

### 隐藏结局二：深渊回响

这是最具挑战性的隐藏结局，需要玩家在整条剧情线中始终保持一致的选择倾向。`,
    category: 'gonglue',
    categoryName: '攻略指南',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20hidden%20ending%20concept%20art%2C%20warm%20golden%20light%20breaking%20through%20darkness%2C%20Chinese%20ink%20wash%20painting%20style%2C%20dramatic%20contrast%2C%20atmospheric%20and%20emotional%2C%20clean%20simple%20background&width=800&height=500&seq=article-yincang-01&orientation=landscape',
    date: '2026-07-05',
    readTime: '10分钟',
    slug: 'jiemian-jiexi'
  },
  {
    id: 'shijieguang-jiedu',
    title: '挣扎吧亚当君完整世界观解读',
    excerpt: '从创世神话到现实隐喻，全方位解读挣扎吧亚当君的宏大世界观架构和深层寓意。',
    content: `## 完整世界观解读

挣扎吧亚当君构建了一个极具层次感的世界观体系。表层是一个现代都市背景下的悬疑故事，深层则是一个关于人性、命运与自由的哲学寓言。

### 世界架构

游戏世界分为三个层次：
- **表层世界**：看似正常的现代都市，亚当君的日常生活场景
- **夹层世界**：在特定条件下才能进入的异空间，这里隐藏着世界的真相
- **深层世界**：只有极少数角色能够触及的终极领域

### 创世神话

在游戏的设定中，世界并非自然形成，而是由一位被称为「织命者」的存在所编织。`,
    category: 'juqing',
    categoryName: '剧情讨论',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grand%20worldbuilding%20concept%20illustration%20with%20layered%20realms%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20Chinese%20mythological%20elements%20blended%20with%20modern%20aesthetic%2C%20dramatic%20and%20atmospheric%2C%20clean%20composition&width=800&height=500&seq=article-shijie-01&orientation=landscape',
    date: '2026-06-28',
    readTime: '14分钟',
    slug: 'shijieguang-jiedu'
  },
  {
    id: 'yinle-jianshang',
    title: '挣扎吧亚当君原声音乐鉴赏指南',
    excerpt: '从主题曲到场景配乐，深度赏析挣扎吧亚当君的原声音乐，感受音乐如何为叙事增添戏剧张力。',
    content: `## 原声音乐鉴赏

音乐是挣扎吧亚当君叙事体验中不可或缺的一部分。由知名作曲家操刀的原声音乐，完美融合了东方传统乐器与现代电子音乐元素。

### 主题曲《挣扎》

主题曲以古筝的悠远旋律开场，逐渐融入电子合成器的低沉脉动，完美诠释了「挣扎」这一核心主题——在传统与现代、命运与自由之间的拉扯。

### 场景配乐精选

每个关键场景都配有专属的主题音乐，这些音乐不仅烘托氛围，更隐含着剧情线索。`,
    category: 'zixun',
    categoryName: '最新资讯',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20musical%20atmosphere%20illustration%20with%20traditional%20Chinese%20instruments%20and%20modern%20elements%2C%20warm%20golden%20tones%2C%20artistic%20ink%20painting%20style%2C%20emotional%20and%20flowing%20composition%2C%20clean%20background&width=800&height=500&seq=article-yinle-01&orientation=landscape',
    date: '2026-06-20',
    readTime: '9分钟',
    slug: 'yinle-jianshang'
  }
];

export const categories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'gonglue', name: '攻略指南' },
  { slug: 'juese', name: '角色解析' },
  { slug: 'juqing', name: '剧情讨论' },
  { slug: 'zixun', name: '最新资讯' }
];